import { withInstall } from '@antdv/utils';
import ACarousel from './src/Carousel';

export const Carousel = withInstall(ACarousel);

export default Carousel;

export * from './src/interface';
export * from './src/props';
